<template>
  <div class="vectorCount" v-loading="loading" element-loading-text="数据加载中...">
    <!--搜索栏-->
    <div class="search">
      <div>
        <div style="font-weight: bold; font-size: 20px">全区林长巡林统计</div>
      </div>
      <div class="search-form">
        <el-select v-model="searchForm.timeType" @change="getTaskCountByTime" placeholder="请选择时间区间" size="medium">
          <el-option label="本月" :value="1"></el-option>
          <el-option label="本年" :value="2"></el-option>
        </el-select>
        <div style="width: 470px; display: flex; justify-content: space-between; align-items: center">
          <el-date-picker v-model="searchForm.startTime" type="date" placeholder="开始日期" style="width: 45%" size="medium" value-format="yyyy-MM-dd" @change="getTaskCountByTime"></el-date-picker>
          <span>-</span>
          <el-date-picker v-model="searchForm.endTime" type="date" placeholder="结束日期" style="width: 45%" size="medium" value-format="yyyy-MM-dd" @change="getTaskCountByTime"></el-date-picker>
        </div>
      </div>
    </div>
    <!--统计-->
    <div class="echartsContainer">
      <div class="topChart">
        <div id="chart1" class="item"></div>
        <div id="chart2" class="item"></div>
        <div id="chart3" class="item"></div>
      </div>
      <div class="topChart2">
        <div id="chart4" class="item"></div>
        <div id="chart5" class="item"></div>
        <div class="item">
          <div style="text-align: center; margin-bottom: 10px; font-weight: bold; font-size: 18px">核查人员统计</div>
          <div>
            <el-table
              class="table"
              :data="tableData"
              align="center"
              ref="table"
              :row-style="{ cursor: 'pointer' }"
              highlight-current-row
              :header-cell-style="{ background: '#f4f7fe' }"
              v-loading="tabloading"
              element-loading-text="数据加载中..."
              @sort-change="sortChange"
            >
              <!-- @row-click="clickRow" -->
              <el-table-column prop="userName" label="林长"></el-table-column>
              <el-table-column prop="sumCount" label="总任务" sortable="custom"></el-table-column>
              <el-table-column prop="finishCount" label="总完成数" sortable="custom"></el-table-column>
              <el-table-column prop="periodAddCount" label="阶段新增数" sortable="custom"></el-table-column>
              <el-table-column prop="periodFinishCount" label="阶段完成数" sortable="custom"></el-table-column>
            </el-table>
            <div class="page">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[5]"
                layout="sizes, prev, pager, next"
                :total="total"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { GetVectorTaskCount, GetVectorTaskCountByTime } from '@/api/vectorTask.js'
  export default {
    name: 'vectorTaskCount', // 模块名称
    components: {},
    props: {},
    data() {
      return {
        searchForm: {
          timeType: 1,
          startTime: '',
          endTime: '',
        }, //搜索表单
        loading: false, // 数据是否处于加载状态
        areaId: -1,
        total: 0, // 数据总数
        currentPage: 1, // 当前页数
        pageSize: 5, // 当前查询数据个数
        topData: {},
        bottomData: {},
        rankType: '',
        orderType: '',
        tableData: {},
        tabloading: false, //l列表是否加载中
      }
    },
    // 页面渲染后
    mounted() {
      this.getTaskCount()
      this.getTaskCountByTime()
    },
    // 方法
    methods: {
      // table排序
      sortChange(column) {
        this.rankType = column.prop
        this.orderType = column.order
        this.getUserList()
      },
      // 分页查询
      handleSizeChange(e) {
        this.pageSize = e
        this.getUserList()
      },
      handleCurrentChange(e) {
        this.currentPage = e
        this.getUserList()
      },
      getUserList() {
        let params = {
          timeType: this.searchForm.timeType,
          startTime: this.searchForm.startTime,
          endTime: this.searchForm.endTime,
          areaId: this.areaId,
          rankType: this.rankType,
          orderType: this.orderType,
          pageSize: this.pageSize,
          pageNumber: this.currentPage,
          isOnlyGetUserInfo: true,
        }
        this.tabloading = true
        GetVectorTaskCountByTime(params).then((res) => {
          if (res.data.state == 1) {
            this.tableData = res.data.data.lis
            this.total = res.data.data.count
            this.tabloading = false
          } else {
            this.tabloading = false
          }
        })
      },
      getTaskCount() {
        let params = {
          timeType: this.searchForm.timeType,
          startTime: this.searchForm.startTime,
          endTime: this.searchForm.endTime,
          areaId: this.areaId,
        }
        GetVectorTaskCount(params).then((res) => {
          if (res.data.state == 1) {
            this.topData = res.data.data
            this.initTopChart()
          }
        })
      },
      getTaskCountByTime() {
        let params = {
          timeType: this.searchForm.timeType,
          startTime: this.searchForm.startTime,
          endTime: this.searchForm.endTime,
          areaId: this.areaId,
          rankType: this.rankType,
          orderType: this.orderType,
          pageSize: this.pageSize,
          pageNumber: this.currentPage,
          isOnlyGetUserInfo: false,
        }
        this.tabloading = true
        GetVectorTaskCountByTime(params).then((res) => {
          if (res.data.state == 1) {
            this.bottomData = res.data.data
            console.log(this.bottomData)
            this.tableData = res.data.data.lis
            this.total = res.data.data.count
            this.tabloading = false
            this.initBottomChart()
          } else {
            this.tabloading = false
          }
        })
      },
      // 初始化顶部统计图数据
      initTopChart() {
        let myChart1 = this.$echarts.init(document.getElementById('chart1'))
        let myChart2 = this.$echarts.init(document.getElementById('chart2'))
        let myChart3 = this.$echarts.init(document.getElementById('chart3'))
        // 指定图表的配置项和数据
        let option1 = {
          title: {
            text: '核查人员',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}人',
          },
          legend: {
            bottom: 10,
            left: 'center',
            data: this.topData.vectorUsersData,
          },
          series: [
            {
              name: '核查人员',
              radius: '65%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              type: 'pie',
              data: this.topData.vectorUsers,
            },
          ],
        }
        let option2 = {
          title: {
            text: '总任务数',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}个',
          },
          legend: {
            bottom: 10,
            left: 'center',
            data: this.topData.vectorSumTaskData,
          },
          series: [
            {
              name: '总任务数',
              radius: '65%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              type: 'pie',
              data: this.topData.vectorSumTask,
            },
          ],
        }
        let option3 = {
          title: {
            text: '总完成数',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}个',
          },
          legend: {
            bottom: 10,
            left: 'center',
            data: this.topData.vectorSumFinishTaskData,
          },
          series: [
            {
              name: '总完成数',
              radius: '65%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              type: 'pie',
              data: this.topData.vectorSumFinishTask,
            },
          ],
        }
        // 使用刚指定的配置项和数据显示图表。

        myChart1.setOption(option1)
        myChart2.setOption(option2)
        myChart3.setOption(option3)
        // myChart1.on('click', params => {
        // 	this.areaId = params.data.areaId
        // 	this.getPatrolDetail(this.areaId)
        // });
        // myChart2.on('click', params => {
        // 	this.areaId = params.data.areaId
        // 	this.getPatrolDetail(this.areaId)
        // });
        // myChart3.on('click', params => {
        // 	this.areaId = params.data.areaId
        // 	this.getPatrolDetail(this.areaId)
        // });
      },
      // 初始化顶部统计图数据
      initBottomChart() {
        let myChart1 = this.$echarts.init(document.getElementById('chart4'))
        let myChart2 = this.$echarts.init(document.getElementById('chart5'))
        // 指定图表的配置项和数据
        let option1 = {
          title: {
            text: '阶段新增任务数',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}个',
          },
          legend: {
            bottom: 10,
            left: 'center',
            data: this.bottomData.vectorAddTaskData,
          },
          series: [
            {
              name: '阶段新增任务数',
              radius: '65%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              type: 'pie',
              data: this.bottomData.vectorAddTask,
            },
          ],
        }
        let option2 = {
          title: {
            text: '阶段完成任务数',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}个',
          },
          legend: {
            bottom: 10,
            left: 'center',
            data: this.bottomData.vectorEndData,
          },
          series: [
            {
              name: '阶段完成任务数',
              radius: '65%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              type: 'pie',
              data: this.bottomData.vectorEndTask,
            },
          ],
        }

        // 使用刚指定的配置项和数据显示图表。

        myChart1.setOption(option1)
        myChart2.setOption(option2)

        // myChart1.on('click', params => {
        // 	this.areaId = params.data.areaId
        // 	this.getPatrolDetail(this.areaId)
        // });
        // myChart2.on('click', params => {
        // 	this.areaId = params.data.areaId
        // 	this.getPatrolDetail(this.areaId)
        // });
      },
      dateChange() {},
      selectDate() {},
    },
  }
</script>

<style lang="less" scoped>
  .vectorCount {
    height: 100%;
    width: 100%;
    .search {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      .search-form {
        display: flex;
        align-items: center;
        .el-select {
          margin-right: 30px;
          width: 220px;
        }
      }
    }
    .echartsContainer {
      height: calc(100vh - 165px);
      margin: 10px;
      display: flex;
      flex-direction: column;
      align-content: space-between;
      .topChart {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item {
          width: 30%;
          height: 380px;
        }
      }
      .topChart2 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item {
          width: 30%;
          height: 380px;
        }
      }
    }
  }
</style>
